import React from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {getFavorites} from "../../actions/getFirestoreData/getFavorites"
import {removeFavorite} from "../../actions/updateFirestoreData/userData/removeFavorite";
import Recipe from "../../components/searchRecipe/Recipe";
import {Typography, Grid, LinearProgress} from '@material-ui/core';


/**
 * This class will contain all information about user's favorites dishes
 * like name, image, how to make it step by step
 */
class Favorites extends React.Component {
    state = {
        favorites: [],
        loading: true
    };

    componentDidMount = async () => {
        let favorites = await this.props.getFavorites(this.props.auth.favoris)

        this.setState({
            favorites,
            loading: false,
        })
    };

    render() {
        const {favorites, loading} = this.state
        if (loading) return <LinearProgress/>
        return (
            <div>
                {favorites.length === 0 ?
                    <Grid container direction="row" justify="center" alignItems="center">
                        <Typography> "vous n'avez pas de favoris pour le moment "  <span role="img" aria-label="sad">😭 </span>️
                        </Typography>
                    </Grid>

                    :
                    <Grid container direction="row" justify='center' spacing={4}>
                        <Grid container direction="row" justify="center" spacing={2}>
                            <Grid item>
                                <Typography variant="h6">Mes favoris <span role="img" aria-label="hearth">❤</span>️
                                </Typography>
                            </Grid>
                        </Grid>

                        {favorites.map((recipe) => (
                            <Grid item xs={12} sm={6}  key={recipe.name}>
                                <Recipe recipe={recipe} auth={this.props.auth}
                                        removeFavorite={this.props.removeFavorite} favorites={favorites}/>
                            </Grid>
                        ))}
                    </Grid>
                }
            </div>
        );
    }
}

const mapStateToProps = ({auth}) => {
    return {auth}
};

export default withRouter(connect(
    mapStateToProps,
    {getFavorites, removeFavorite}
)(Favorites))
